import React from 'react'

import Spinner from 'app/components/Spinner'
import GlobalLoader from 'app/components/Loaders/GlobalLoader'

const GlobalLoaderOrSpinner = ({ isTranslationsCommonLoaded }) =>
  isTranslationsCommonLoaded ? <GlobalLoader /> : <Spinner />

export default GlobalLoaderOrSpinner
